import { useFormik } from "formik";
import { publicIpv4 } from "public-ip";
import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import * as Yup from "yup";
import { isOTPVerified, saveUserData, } from "../../../../features/persist/persistSlice";
import { getUserInfoAction, userLoginAction } from "../../../../features/user/userSlice";
import { validationMessage } from "../../../../Helper/helperfunction";
import { ROUTES } from "../../../../routes";
import { Messages, TYPE } from "../../../../utils/constants";
import Button from "../../../common/Button/Button";
import InputFormik from "../../../common/Formik/Input/InputFormik";
import Password from "../../../common/Formik/Password/Password";
import styles from "../../../layouts/OnboardLayout/OnboardLayout.module.scss";

const Login = () => {
  const dispatch = useDispatch();
  const [ipAddress, setIpAddress] = useState("0.0.0.0");
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  let sessionExpiredMessageShown = false;

  const validationSchema = Yup.object({
    username: Yup.string()
      .label("Username")
      .required(validationMessage("Username"))
      .min(4),
    password: Yup.string()
      .required(validationMessage("Password"))
      .min(8, Messages?.passwordOfSixCharacters)
      .max(40, Messages?.passwordMaxCharacters),
  });

  const formik = useFormik({
    initialValues: {
      username: "",
      password: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values, { resetForm }) => {
      sessionExpiredMessageShown = false;
      const data = {
        username: values.username,
        password: values.password,
        deviceType: TYPE?.DEVICE_TYPE,
        ipAddress: ipAddress || "0.0.0.0",
      };

      try {
        const response = await dispatch(userLoginAction(data));

        if (response?.status === 200) {
          resetForm();
          getUserProfile();
        } else {
          console.error("Unexpected login response:", response);
        }
      } catch (error) {
        setIsLoggedIn(true);
        console.error("Something went wrong during login:", error);
      }
    },
  });


  const getUserProfile = async () => {
    try {
      const response = await dispatch(getUserInfoAction());
      if (response?.status === 200) {
        dispatch(saveUserData(response.data.data));
      } else {
        console.log("Error fetching user info:", response);
      }
    } catch (error) {
      console.error("Something went wrong while fetching user profile:", error);
    }
  };

  useEffect(() => {
    if (isLoggedIn) {
      setTimeout(() => {
        setIsLoggedIn(false);
      }, 5000);
    }
  }, [isLoggedIn]);

  useEffect(() => {
    dispatch(isOTPVerified(false));
    ipGet();

    const handleGlobalError = (event) => {
      
    };
    window.addEventListener("error", handleGlobalError);

    const handleWindowClick = (e) => {
      
    };
    window.addEventListener("click", handleWindowClick);

    return () => {
      window.removeEventListener("error", handleGlobalError);
      window.removeEventListener("click", handleWindowClick);
    };
  }, []);

  const ipGet = async () => {
    try {
      let data = await publicIpv4();
      setIpAddress(data);
    } catch (error) {
      console.error("Error fetching IP address:", error);
      setIpAddress("0.0.0.0");
    }
  };

  return (
    <div className={styles.onboard_box}>
      <h2>Login</h2>
     

      <form
        method="POST"
        noValidate
        onSubmit={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        <InputFormik
          control="input"
          type="text"
          className={styles.input}
          name="username"
          placeholder="Please enter your Username or email"
          label="Username or Email"
          value={formik.values.username}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          formik={formik}
        />
        <Password
          control="input"
          type="text"
          className={styles.input}
          name="password"
          placeholder="Enter your Password"
          label="Password"
          value={formik.values.password}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          formik={formik}
        />
        <p className={`${styles.link_text} ${styles.lg_text}`}>
          <Link className={styles.bold} to={ROUTES.FORGOT_EMAIL_VERIFICATION}>
            Forgot Password?
          </Link>
        </p>
        <div className={styles.submit_btn}>
          <Button
            fluid
            type="button"
            onClick={(e) => {
              formik.handleSubmit(e);
            }}
            disabled={isLoggedIn || !(formik.isValid && formik.dirty)}
          >
            {formik.isSubmitting ? "Processing..." : "Login"}
          </Button>
        </div>
        <p className={styles.link_text}>
          Don't have an account?{" "}
          <Link className={styles.bold} to={ROUTES.REGISTER}>
            Create Account
          </Link>
        </p>
      </form >
    </div >
  );
};

export default Login;